import React from 'react';

// The visible 2D/3D dimension chooser extracted from CreatePage's `dimension-options`.
// Only the picker cards live here; CreatePage keeps its hidden 3D render canvas + admin
// controls inline (the new referral/event pages never need those — 3D is server-rendered).
const DEFAULT_FALLBACK_IMAGE = '/demo-maps/itoshima-ride.png';

function DimensionSelectionSection({
  styleGroup,
  dimension,
  onChangeDimension,
  fallbackImageUrl = DEFAULT_FALLBACK_IMAGE,
  threeDLabel = '3D Terrain',
  twoDLabel = '2D Classic',
  // Overrides the styleGroup.has3D gate — e.g. Zwift 3D-world activities offer
  // 3D via the terrain renderer even for styles without a 3D template.
  show3DOption = null,
}) {
  if (!styleGroup) return null;

  const example3D = styleGroup.templates?.find((t) => t.mapInputType === '3d')?.exampleImageUrl ||
    styleGroup.templates?.find((t) => t.mapInputType !== '3d')?.exampleImageUrl ||
    fallbackImageUrl;
  const example2D = styleGroup.templates?.find((t) => t.mapInputType !== '3d')?.exampleImageUrl || fallbackImageUrl;
  const has3D = show3DOption ?? styleGroup.has3D;

  return (
    <div className="dimension-options">
      {has3D && (
        <div
          className={`dimension-card ${dimension === '3d' ? 'selected' : ''}`}
          onClick={() => onChangeDimension?.('3d')}
        >
          <div className="dimension-preview">
            <img src={example3D} alt="3D Preview" />
          </div>
          <p className="dimension-label">{threeDLabel}</p>
          {dimension === '3d' && <div className="selection-check">✓</div>}
        </div>
      )}
      {styleGroup.has2D && (
        <div
          className={`dimension-card ${dimension === '2d' ? 'selected' : ''}`}
          onClick={() => onChangeDimension?.('2d')}
        >
          <div className="dimension-preview">
            <img src={example2D} alt="2D Preview" />
          </div>
          <p className="dimension-label">{twoDLabel}</p>
          {dimension === '2d' && <div className="selection-check">✓</div>}
        </div>
      )}
    </div>
  );
}

export default DimensionSelectionSection;
